exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ref-about{margin:10px;margin-bottom:64px;text-align:center}", ""]);

